export const DEVICE_ORDER_STATUS = {
  OPEN: -2,
  ALL: -1,
  AWAITING_APPROVAL: 0,
  REJECTED: 1,
  AT_VENDOR: 2,
  PROCESSED: 3,
  DELIVERED: 4,
  SENT_TO_ECOM: 5,
}

export const getDeviceOrderStatusTextId = (status, whiteLabel = 'skytech') => {
  if (whiteLabel === 'mobit' && status === DEVICE_ORDER_STATUS.SENT_TO_ECOM) {
    return `Sent to Multicase`
  }
  return `STATUS_DEVICE_ORDER/${status}`
}

export const SUBSCRIPTION_ORDER_TYPES = {
  PORTING: 22,
  UPGRADE: 'UPGRADE',
  TERMINATION: 23,
}

export const SUBSCRIPTION_ORDER_STATUS = {
  FOR_MANUAL_HANDLING: -3,
  OPEN: -2,
  ALL: -1,
  WAITING_FOR_USER: 0,
  WAITING_FOR_DEALER: 0.5,
  PROCESSING: 1,
  DONE: 2,
  TERMINATION_REQUEST: 3,
  TERMINATED: 4,
  CANCELED: 5,
  FAILED: 9,
}

export const getSubscriptionOrderStatusTextId = status => `STATUS_SUBSCRIPTION_ORDER/${status}`

export const getSubscriptionOrderTypeTextId = serviceId => {
  switch (serviceId) {
    case SUBSCRIPTION_ORDER_TYPES.PORTING:
      return `TYPE_SUBSCRIPTION_ORDER/PORTING`
    case SUBSCRIPTION_ORDER_TYPES.TERMINATION:
      return `TYPE_SUBSCRIPTION_ORDER/TERMINATION`
    default:
      return `TYPE_SUBSCRIPTION_ORDER/UPDGRADE`
  }
}

export const TERMINATION_TYPE = {
  TRANSFER: 0,
  CANCELLATION: 2,
  USER_DECIDES: 3,
}

export const isOrderOfType = (order, orderType) => {
  switch (orderType) {
    case SUBSCRIPTION_ORDER_TYPES.PORTING:
      return order.subscription_service_id === 22
    case SUBSCRIPTION_ORDER_TYPES.TERMINATION:
      return order.subscription_service_id === 23
    default:
      return order.subscription_service_id !== 22 && order.subscription_service_id !== 23
  }
}

export const isSubscriptionOrderWaitingForUser = order =>
  isPortingnOrderWaitingForUser(order) || isTerminationOrderWaitingForUser(order)

const isPortingnOrderWaitingForUser = order =>
  isOrderOfType(order, SUBSCRIPTION_ORDER_TYPES.PORTING) &&
  order.status === SUBSCRIPTION_ORDER_STATUS.WAITING_FOR_USER &&
  !order.is_business_sub &&
  !order.is_new_number &&
  !order.code

const isTerminationOrderWaitingForUser = order =>
  isOrderOfType(order, SUBSCRIPTION_ORDER_TYPES.TERMINATION) &&
  order.status === SUBSCRIPTION_ORDER_STATUS.WAITING_FOR_USER &&
  order.termination_type_id !== TERMINATION_TYPE.CANCELLATION &&
  (!order.birth_date_org_no || !order.credit_check_acceptance_given)

export const ECOM_STATUS = {
  OPEN: -2,
  ALL: -1,
  NEW: 0,
  ACCEPTED: 1,
  CONFIRMED: 2,
  DELIVERED: 3,
  PARTIALLY_DELIVERED: 4,
  AWAITING_APPROVAL: 5,
  REJECTED: 6,
  CANCELED: 9,
  ERROR: 99,
}

export const getShopOrderStatusTextId = status => `STATUS_SHOP_ORDER/${status}`
